import { render, staticRenderFns } from "./SelectUpload.vue?vue&type=template&id=383cda3a&scoped=true"
import script from "./SelectUpload.vue?vue&type=script&lang=js"
export * from "./SelectUpload.vue?vue&type=script&lang=js"
import style0 from "./SelectUpload.vue?vue&type=style&index=0&id=383cda3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383cda3a",
  null
  
)

export default component.exports